// ============================================================================
// PORTFOLIO CONTENT - Rulio Macedo, Web Designer Full Stack
// ============================================================================

export interface Service {
  title: string
  description: string
  icon: string
}

export interface Project {
  title: string
  category: string
  description: string
  tags: string[]
  year: string
}

export interface SkillGroup {
  label: string
  items: string[]
}

export interface Stat {
  value: string
  label: string
}

export const profile = {
  name: 'Rulio Macedo',
  role: 'Web Designer Full Stack',
  location: 'Brasil · Remoto',
  headline: 'Desenho e desenvolvo experiências digitais que unem estética e engenharia.',
  intro:
    'Trabalho na fronteira entre design e código, transformando ideias em produtos digitais rápidos, acessíveis e memoráveis — do primeiro rascunho no Figma até o deploy em produção.',
  email: 'contato@ruliomacedo.com',
  socials: [
    { label: 'GitHub', href: 'https://github.com' },
    { label: 'LinkedIn', href: 'https://linkedin.com' },
    { label: 'Dribbble', href: 'https://dribbble.com' },
    { label: 'Instagram', href: 'https://instagram.com' },
  ],
}

export const stats: Stat[] = [
  { value: '8+', label: 'anos de experiência' },
  { value: '60+', label: 'projetos entregues' },
  { value: '30+', label: 'clientes satisfeitos' },
  { value: '100%', label: 'foco em performance' },
]

export const services: Service[] = [
  {
    title: 'UI / UX Design',
    description:
      'Interfaces intencionais construídas a partir de pesquisa, wireframes e protótipos de alta fidelidade no Figma.',
    icon: 'design',
  },
  {
    title: 'Front-end',
    description:
      'Desenvolvimento de interfaces responsivas e performáticas com React, Next.js, TypeScript e Tailwind CSS.',
    icon: 'code',
  },
  {
    title: 'Back-end & APIs',
    description:
      'Arquitetura de servidores, bancos de dados e APIs escaláveis com Node.js, FastAPI e PostgreSQL.',
    icon: 'server',
  },
  {
    title: 'Otimização & SEO',
    description:
      'Core Web Vitals, acessibilidade e SEO técnico para produtos que carregam rápido e são encontrados.',
    icon: 'rocket',
  },
]

export const skills: SkillGroup[] = [
  { label: 'Design', items: ['Figma', 'Design System', 'Prototipagem', 'Wireframing', 'Motion'] },
  { label: 'Front-end', items: ['React', 'Next.js', 'TypeScript', 'Tailwind CSS', 'Framer Motion'] },
  { label: 'Back-end', items: ['Node.js', 'FastAPI', 'PostgreSQL', 'REST', 'JWT Auth'] },
  { label: 'DevOps', items: ['Docker', 'Nginx', 'CI/CD', 'Vercel', 'Git'] },
]

export const projects: Project[] = [
  {
    title: 'Nébula Commerce',
    category: 'E-commerce',
    description:
      'Plataforma de e-commerce headless com checkout otimizado e painel administrativo em tempo real.',
    tags: ['Next.js', 'FastAPI', 'PostgreSQL'],
    year: '2025',
  },
  {
    title: 'Aurora Finance',
    category: 'Fintech Dashboard',
    description:
      'Dashboard financeiro com visualização de dados, autenticação segura e experiência mobile-first.',
    tags: ['React', 'TypeScript', 'D3'],
    year: '2024',
  },
  {
    title: 'Vértice Studio',
    category: 'Landing Page',
    description:
      'Site institucional para estúdio criativo com animações fluidas e foco em conversão.',
    tags: ['Next.js', 'Framer Motion', 'Tailwind'],
    year: '2024',
  },
  {
    title: 'Órbita SaaS',
    category: 'Produto SaaS',
    description:
      'Aplicação SaaS multi-tenant com design system próprio e API modular de alta performance.',
    tags: ['Next.js', 'Node.js', 'Docker'],
    year: '2023',
  },
]

export const process = [
  {
    step: '01',
    title: 'Descoberta',
    description: 'Entendo o problema, o público e os objetivos de negócio antes de qualquer pixel.',
  },
  {
    step: '02',
    title: 'Design',
    description: 'Construo wireframes e protótipos navegáveis, validando decisões cedo.',
  },
  {
    step: '03',
    title: 'Desenvolvimento',
    description: 'Codifico com boas práticas, componentes reutilizáveis e testes.',
  },
  {
    step: '04',
    title: 'Entrega',
    description: 'Deploy, monitoramento de performance e suporte contínuo pós-lançamento.',
  },
]

export const marqueeItems: string[] = [
  'UI/UX Design',
  'Next.js',
  'React',
  'TypeScript',
  'FastAPI',
  'Design System',
  'Tailwind CSS',
  'Framer Motion',
  'PostgreSQL',
  'Docker',
  'Performance',
  'Acessibilidade',
]
